export const SITE_URL = "https://windows.dogdayrenovations.com";
export const SITE_NAME = "Dog Day Renovations";
export const SITE_PHONE_DISPLAY = "(336) 893-4447";
export const SITE_PHONE_TEL = "+13368934447";
export const SITE_PHONE_HREF = "tel:3368934447";
export const SITE_EMAIL = "info@dogdayrenovations.com";
export const SITE_POSTAL_CODE = "27107";
export const SITE_CITY = "Winston-Salem";
export const SITE_REGION = "NC";
export const SITE_COUNTRY = "US";
export const PARENT_SITE = "https://dogdayrenovations.com/";
export const GOOGLE_REVIEWS = "https://share.google/zJbX2URu9K2ZvG8ns";
export const SOCIAL_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/H11f8sPnVxbVMPidooAs9ItoKYe2/social-images/social-1779471077544-Logo_HighRes_(1).webp";
export const LOGO_URL = `${SITE_URL}/logo.webp`;
export const HERO_SRC = "/hero-home-1280.webp";
export const HERO_SRCSET =
  "/hero-home-768.webp 768w, /hero-home-1280.webp 1280w, /hero-home-1536.webp 1536w, /hero-home-1920.webp 1920w";
export const HERO_SIZES = "100vw";
/** HTTP Link header so the LCP image starts before HTML finishes parsing. */
export const HERO_PRELOAD_LINK = `<${HERO_SRC}>; rel=preload; as=image; type=image/webp; fetchpriority=high; imagesrcset="${HERO_SRCSET}"; imagesizes="${HERO_SIZES}"`;

export const SERVICE_CITIES = [
  "Winston-Salem",
  "Greensboro",
  "High Point",
  "Kernersville",
  "Clemmons",
  "Lewisville",
  "Advance",
  "Walkertown",
  "Pfafftown",
] as const;

export const NAV_LINKS = [
  { href: "/#benefits", label: "Benefits" },
  { href: "/#styles", label: "Styles" },
  { href: "/#process", label: "Process" },
  { href: "/#reviews", label: "Reviews" },
  { href: "/#faq", label: "FAQ" },
  { href: "/blog", label: "Blog" },
  { href: "/#quote", label: "Free Quote" },
] as const;

export const PAGE_TITLE = "Window Installation in Winston-Salem, NC | Dog Day Renovations";
export const PAGE_DESCRIPTION =
  "Energy-efficient replacement windows installed by a trusted local team. Free quotes, honest pricing, and quality craftsmanship across Winston-Salem and the NC Triad.";

export const businessJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LocalBusiness", "HomeAndConstructionBusiness"],
      "@id": `${SITE_URL}/#business`,
      name: SITE_NAME,
      alternateName: "Dog Day Renovations — Window Installation",
      url: SITE_URL,
      image: [SOCIAL_IMAGE, LOGO_URL],
      logo: LOGO_URL,
      telephone: SITE_PHONE_TEL,
      email: SITE_EMAIL,
      priceRange: "$$",
      currenciesAccepted: "USD",
      paymentAccepted: "Cash, Check, Credit Card",
      address: {
        "@type": "PostalAddress",
        addressLocality: SITE_CITY,
        addressRegion: SITE_REGION,
        postalCode: SITE_POSTAL_CODE,
        addressCountry: SITE_COUNTRY,
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 36.0999,
        longitude: -80.2442,
      },
      areaServed: SERVICE_CITIES.map((city) => ({
        "@type": "City",
        name: city,
        containedInPlace: {
          "@type": "AdministrativeArea",
          name: "Piedmont Triad",
          addressRegion: "NC",
          addressCountry: "US",
        },
      })),
      description:
        "Energy-efficient replacement window sales and professional installation in Winston-Salem, NC. Free quotes, honest pricing, and quality craftsmanship from a locally owned team.",
      knowsAbout: [
        "Replacement windows",
        "Energy-efficient windows",
        "Vinyl windows",
        "Double-hung windows",
        "Casement windows",
        "Bay and bow windows",
        "Sliding and patio doors",
      ],
      sameAs: [PARENT_SITE, GOOGLE_REVIEWS],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: SITE_PHONE_TEL,
        contactType: "sales",
        email: SITE_EMAIL,
        areaServed: "US-NC",
        availableLanguage: ["English"],
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Window installation services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Double-hung replacement windows" },
          },
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Casement replacement windows" },
          },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Bay and bow windows" } },
          {
            "@type": "Offer",
            itemOffered: { "@type": "Service", name: "Sliding and patio door installation" },
          },
          {
            "@type": "Offer",
            name: "Free in-home window quote",
            price: "0",
            priceCurrency: "USD",
            url: `${SITE_URL}/#quote`,
          },
        ],
      },
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_URL}/#website`,
      url: SITE_URL,
      name: "Dog Day Renovations Window Installation",
      publisher: { "@id": `${SITE_URL}/#business` },
      inLanguage: "en-US",
    },
    {
      "@type": "WebPage",
      "@id": `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: PAGE_TITLE,
      description: PAGE_DESCRIPTION,
      isPartOf: { "@id": `${SITE_URL}/#website` },
      about: { "@id": `${SITE_URL}/#business` },
      primaryImageOfPage: SOCIAL_IMAGE,
      inLanguage: "en-US",
      speakable: {
        "@type": "SpeakableSpecification",
        cssSelector: ["h1", "#benefits", "#faq", "#quote"],
      },
    },
    {
      "@type": "Service",
      "@id": `${SITE_URL}/#service`,
      name: "Replacement window installation",
      serviceType: "Window installation",
      provider: { "@id": `${SITE_URL}/#business` },
      areaServed: `${SITE_CITY}, ${SITE_REGION} and the Piedmont Triad`,
      url: SITE_URL,
      offers: {
        "@type": "Offer",
        name: "Free in-home consultation and quote",
        price: "0",
        priceCurrency: "USD",
        url: `${SITE_URL}/#quote`,
        availability: "https://schema.org/InStock",
      },
    },
  ],
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How long does window installation take?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Most window installations are completed in a single day, depending on the number of windows and project scope. We provide a clear timeline before work begins so you know exactly what to expect.",
      },
    },
    {
      "@type": "Question",
      name: "Will new windows really improve energy efficiency?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Modern replacement windows reduce heat loss, prevent drafts, and improve insulation. Most homeowners notice better comfort and lower energy bills right away.",
      },
    },
    {
      "@type": "Question",
      name: "Do you handle removal and cleanup of old windows?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Absolutely. We remove and properly dispose of your old windows, protect your home during installation, and complete a full cleanup once the job is finished.",
      },
    },
    {
      "@type": "Question",
      name: "What areas do you serve?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We're based in Winston-Salem, NC (27107) and serve homeowners throughout the Triad — including Greensboro, High Point, Kernersville, Clemmons, and surrounding communities.",
      },
    },
    {
      "@type": "Question",
      name: "Is the quote really free?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. Free, in-home, no obligation. We'll measure, recommend, and get you a quote you can think over in a reasonable time.",
      },
    },
  ],
};
